import { AfterContentInit, Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { AuthenticationService } from '../../core/authentication/authentication.service';
// import { LoaderService } from '../../shared/components/loader/loader.service';
// import { DOCUMENT } from '@angular/common';
@Component({
    selector: 'app-login',
    template: `
    <div>
        <div class="loading modal-backdrop" style="z-index: 10000"></div>
        <div class="lds-ellipsis">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>  
    </div>
    `,
    styles: [``]
})
export class LoginComponent implements OnInit, AfterContentInit {

    constructor(
        private authService: AuthenticationService,
        private oidcSecurityService: OidcSecurityService,
        // private loaderService: LoaderService,
        // @Inject(DOCUMENT) private document: Document,
        // private renderer: Renderer2

    ) {
    }
    ngOnInit() {
        // this.renderer.addClass(this.document.body, 'loading')
        if (this.oidcSecurityService.moduleSetup) {
            this.authService.login();
        } else {
            this.oidcSecurityService.onModuleSetup.subscribe(() => {
                this.authService.login();
            });
        }
    }

    ngAfterContentInit(): void {
    }

    ngOnDestroy(): void {
        // this.renderer.removeClass(this.document.body, 'loading')
    }
}
